import React, { createContext, useContext, useEffect, useState } from 'react';
import { tenantApi } from '@vmos2/core';

const StoreContext = createContext();

export const StoreProvider = ({ storeUUID, children }) => {
  const [store, setStore] = useState();
  const abortController = new AbortController();

  useEffect(() => {
    if (storeUUID) {
      tenantApi
        .get(`stores/${storeUUID}`, {
          skipAuth: true,
          cache: { ttl: 3600 * 1000 },
        })
        .then(store => {
          if (!abortController.signal.aborted) {
            setStore(store);
          }
        });
    }
  }, [storeUUID]);

  useEffect(() => () => { abortController.abort('Component was unmounted'); }, []);

  return <StoreContext.Provider value={store}>{store ? children : null}</StoreContext.Provider>;
};

export const useStore = () => {
  return useContext(StoreContext);
};
